// 三才配置数据
// 基于三才数理 (天才、人才、地才) 的五行属性和吉凶判断

// 数字对应五行属性 (1-10循环)
export const NUMBER_TO_ELEMENT = {
  1: '木', 2: '木',
  3: '火', 4: '火', 
  5: '土', 6: '土',
  7: '金', 8: '金',
  9: '水', 0: '水'
}

// 根据数字末位判断五行
export const getElementByNumber = (number) => {
  const lastDigit = number % 10
  return NUMBER_TO_ELEMENT[lastDigit]
}

// 五行相生相克关系
export const FIVE_ELEMENTS_RELATION = {
  // 相生关系：木生火，火生土，土生金，金生水，水生木
  生: {
    '木': '火',
    '火': '土', 
    '土': '金',
    '金': '水',
    '水': '木'
  },
  // 相克关系：木克土，土克水，水克火，火克金，金克木
  克: {
    '木': '土',
    '土': '水',
    '水': '火', 
    '火': '金',
    '金': '木'
  }
}

// 判断两个五行的关系
export const getElementRelation = (element1, element2) => {
  if (element1 === element2) return '同'
  if (FIVE_ELEMENTS_RELATION.生[element1] === element2) return '生'
  if (FIVE_ELEMENTS_RELATION.克[element1] === element2) return '克'
  if (FIVE_ELEMENTS_RELATION.生[element2] === element1) return '被生'
  if (FIVE_ELEMENTS_RELATION.克[element2] === element1) return '被克'
  return '无关'
}

// 完整的三才配置吉凶数据
// 按照五行顺序排列：木→火→土→金→水
// 每个配置包含：type(吉凶等级)、numbers(数字组合)、description(详细描述)
export const THREE_TALENTS_FORTUNE = {
  // 木系配置
  '木木木': { 
    type: '大吉',
    numbers: ['111', '222'],
    description: '成功顺利伸展，希望圆满达成，基础安定，得能向上发展，家门昌隆，身心健全，保得长寿幸福，若巧遇（连珠局）者更加三倍以上之福力，但此为参天巨木大森林之象，须知树大招风，须提防他人之妒贤而多招风波之中伤。'
  },
  '木木火': { 
    type: '大吉',
    numbers: ['113', '224'],
    description: '成功顺利伸展，无障碍而向上发达，基础境遇亦安泰，事事顺利，兴盛隆昌，终生得幸福繁荣，身心健泰，保得长寿幸福。'
  },
  '木木土': { 
    type: '大吉',
    numbers: ['115', '226'],
    description: '人格之木立于地格土之上，顺应天地自然之妙配，莫作木克土论，此局兆，乃必安泰自在，境遇坚固稳当，如立盘石之安泰一般，能成功发达，容易达成目的，名利双收，顺利发展，幸福长寿，但切戒贪污，否则招凶以受渎职犯法之罪惩。'
  },
  '木木金': { 
    type: '凶多吉少',
    numbers: ['117', '228'],
    description: '虽因苦心奋斗而有成功运，但基础运劣，故伸张无力，又境遇多变，常受迫害，难得平安，屡受下属威胁，为部下而致损失，劳烦、失败等，心情苦闷。（但若人格与他人格之阴阳异性：则其凶，减轻些。）'
  },
  '木木水': { 
    type: '吉多于凶',
    numbers: ['119', '220'],
    description: '成功运很不错，足可顺调发展，配置大吉。但只怕人格数或地格数为凶数，则：最末终归渐渐的失意，流亡，失败，烦闷，刑伤，病弱，被药所杀，或招致流浪或放浪，挥霍之兆。（但若人格与地格之阴阳异性：则其凶减轻些。）'
  },
  '木火木': { 
    type: '凶', 
    description: '基础运被环境克制，难于伸张，易生不平，内外不和，境遇虽艰苦尚可自立。'
  },
  '木火火': { 
    type: '中吉',
    numbers: ['133', '244'],
    description: '起初难免有孤革奋斗之感，但斗志激昂，终排除困难，达到顺调，成功发达，尤能得上位之惠肋而更伸张发展。但似乎乏其持久，耐久力，以致虽是成败交加频见，总之大体还算安然，但须防火灾或烫伤之灾。人地格皆23数：甚好淫。'
  },
  '木火土': { 
    type: '大吉',
    numbers: ['135', '246'],
    description: '基础坚实，心身安泰，奴上位之引进而顺调成功发展，能享得幸福，长寿，圆满。'
  },
  '木火金': { 
    type: '凶多吉少',
    numbers: ['137', '248'],
    description: '虽因勤奋而达顺调成功，外见安稳，内实不然，基础不安定致家庭违和，且受部下之迫害，徒劳无功，终于逐渐崩溃，而致失败。'
  },
  '木火水': { 
    type: '大凶',
    numbers: ['139', '240'],
    description: '水火相克，其危早验！基础极端之不安定，（尤其人格数与地格数之相差数：若正是（六数）之名，其凶加倍！）恐遇意外灾祸，有凶变，急死，意外不测，甚至丧失生命、财产，危机四伏之短寿兆。'
  },
  '木土木': { 
    type: '大凶',
    numbers: ['151', '262'],
    description: '境遇不良，住居多移，环境不安定，职业受挫，成为孤独。基础运：崩破。成功运：毁坏。运命被抑压，不可能成功，永无法伸展。不但易犯严重肠胃病，且短寿易死之兆。'
  },
  '木土火': { 
    type: '中吉',
    numbers: ['153', '264'],
    description: '基础运吉而能达有限之成就，但因成功运受到压制，故成功之后便难再伸展了，宜养（仁德雅量），可逃灾害而得平安。'
  },
  '木土土': { 
    type: '吉',
    numbers: ['155', '266'],
    description: '虽易产生不平、不满之念，招致家庭不和，但幸因知机，而养成（仁德雅量）而能亨通安详，总之大体平顺幸福，而必有相当之成就，只因成功运受到压制，故成功之后，恐难再伸展。'
  },
  '木土金': { 
    type: '吉多于凶',
    numbers: ['157', '268'],
    description: '基础运佳而成功运劣，虽无大发展，但亦安定，温饱无虑，但成功运被压迫以致不能再伸张发达，故好发牢骚，幸而德量好，小过难免，但不致成祸厄。'
  },
  '木土水': { 
    type: '大凶',
    numbers: ['159', '260'],
    description: '基础运崩败，成功运亦毁坏，命运势劣，被压不伸，容易遭遇转劣或凶厄、急难、变死、危机四伏，短寿之兆，生命难保，幸若人格数是15数或35。数者：虽最优良，仅可保免致短寿，但身心会易过劳。'
  },
  '木金木': { 
    type: '大凶',
    numbers: ['171', '282'],
    description: '外表似安定，内实不然，困难重重以迭卷而来，永不休止，境遇困苦，身心过劳，甚难以成功，即使勉强成功也很快再败，易惹祸端而变为短寿，或损脑筋，变成思想偏歧不正，或多遭危身灾险，家庭亦多不幸诸灾。'
  },
  '木金火': { 
    type: '大凶',
    numbers: ['173', '284'],
    description: '绝对不安定，多遇小人之暗害，身心过劳，基础运崩败，成功运毁坏，不能成功，即使勉强成功亦旋即再败，或损脑筋，变成思想偏倚不正，或多遭危身灾险，甚至发狂、自杀、变死诸祸端，此乃短寿之兆。'
  },
  '木金土': { 
    type: '凶', 
    description: '可得有一时之成功，但基础非安定，配置于不吉，终局之凶。'
  },
  '木金金': { 
    type: '大凶',
    numbers: ['177', '288'],
    description: '过于坚刚而被人排斥，陷于不和、孤独，身心过劳，容易遭难，失败，伤害脑以致思想偏倚不正，家庭破乱，除非意志坚刚不拔而终可成功，否则其成功运至劣，难于展志成业，易惹祸端而变为短寿。'
  },
  '木金水': { 
    type: '大凶',
    numbers: ['179', '280'],
    description: '虽努力勤奋，但徒劳少得，常有烦脑不安，终因身心过劳而一再失败，陷于急变、没落、遭难、变死之悲运，虽庆喜人格与地格俱吉数，而有一时之安定成功，但为时不久。'
  },
  '木水木': { 
    type: '大吉',
    numbers: ['191', '202'],
    description: '得境遇安全，能逃灾厄，成功运佳，顺利成功发展，配置良好，但只怕人、地两格，若有凶数者：家庭变成诸多不幸，因之导致失败之虑，若无凶数，则可免忧也。'
  },
  '木水火': { 
    type: '凶多吉少',
    numbers: ['193', '204'],
    description: '一时博得名利，因基础不稳，水火急变，最终也凶，易生病难、急祸、克妻与家庭之不幸，若人格数与地格数：相差了六数，乃犯六冲之短命兆，有大凶厄或变死之虑。'
  },
  '木水土': { 
    type: '凶多吉少',
    numbers: ['195', '206'],
    description: '一时虽可得成功，但会渐渐的崩溃而归于失败，表面安定，内有急祸，心情烦闷不安，容易生突发之急变灾难，甚至发生料想不到之灾危或祸端。'
  },
  '木水金': { 
    type: '大吉',
    numbers: ['197', '208'],
    description: '基础安定，成功运佳，财利名誉俱得并大发展之势，健康、长寿、幸福之兆，唯若人格或地格若凶数，恐因好大，喜功，行事亦易招败，若无凶数，则可免忧虑。'
  },
  '木水水': { 
    type: '大吉',
    numbers: ['199', '200'],
    description: '前运虽苦而后运甘甜，能顺利成功并大发展，为富豪，享长寿安宁，但人格、地格若凶数恐有病弱或流亡失所之虑，若无凶数，则可免忧虑。'
  },
  // 火系配置
  '火木木': { 
    type: '大吉',
    numbers: ['311', '422'],
    description: '基础安泰，贵人相助，向上发展，易迅速达成目的，而得大成功发展，享洪福又长寿。'
  },
  '火木火': { 
    type: '大吉',
    numbers: ['313', '424'],
    description: '由努力至成功，向上发展，诸志易成，百事安泰，身心健康，得享长寿富荣，但因火力过大，提防火灾或烫伤之险，若无凶数，则可免忧虑。'
  },
  '火木土': { 
    type: '大吉',
    numbers: ['315', '426'],
    description: '基础坚固，毫无变动，如立盘石之上发展，达成目的，向上进取，努力奋斗，容易成功富贵，顺利发展，安泰健身长寿。'
  },
  '火木金': { 
    type: '凶多吉少',
    numbers: ['317', '428'],
    description: '可以发展成功，但境遇不安定，易转变移动，受下部之迫害殊多，身心过劳，多变化终于转败，且须防有交通事故之危险，另一方面也须提防被武器杀伤或外伤大流血之虑。'
  },
  '火木水': { 
    type: '中吉',
    numbers: ['319', '420'],
    description: '因勤勉而成功发展，名成利就之吉兆无疑。（但只怕人格、地格为凶数，则易生家庭之杂乱，再加以天地格水火相克，会恐好景不长，必有失败之一天）。'
  },
  '火火木': { 
    type: '大吉',
    numbers: ['331', '442'],
    description: '境遇巩固有下属之助，地位财产，俱为安全，排除诸障碍，凡事如意，盛运隆昌荣誉，助者或共事者亦得一帆风顺而成功发展。（但若有凶数者，亦须提防火灾或烫伤之事）但人格23数、地格21数备全者，而他格有凶数者：很可能好淫无节制。'
  },
  '火火火': { 
    type: '凶', 
    description: '虽有一时之成功，但境遇不稳，常有转移困感，妨害难免，心身过劳而失败。'
  },
  '火火土': { 
    type: '大吉',
    numbers: ['335', '446'],
    description: '吉祥顺遂，成功发展之吉兆，但若人格、地格有凶数，易生不良诱导，终陷于灾难悲运，被人陷害连累等，甚至有财败人离之虑，若人地二格无凶数，则大体是长寿幸福的。'
  },
  '火火金': { 
    type: '大凶',
    numbers: ['337', '448'],
    description: '一时虽可得成功，但外见安稳而内实不然，为人过分风流好淫而又常受不良之部下陷害，以致身心过劳，终至失败或夫妻激烈不睦，双火克一金，很可能与人结怨仇而发生祸端杀人或被杀，或遭火灾，乃双死之短寿兆。'
  },
  '火火水': { 
    type: '大凶',
    numbers: ['339', '440'],
    description: '风流成性之极，而又非常不安定之命运，易生意外之凶变或遭水火袭击，即使一时侥幸而成功，但亦不能持久，终陷于危祸，受意外灾难而破财或丧生，变死之机遇特多之凶兆，此乃发生不测突变而致死之兆。'
  },
  '火金木': { 
    type: '大凶',
    numbers: ['371', '482'],
    description: '命运完全被抑压，基础运亦劣，常常劳而无功，极困难伸展其成就，若不谨慎，则致颠覆，易招失意及失配偶，或遭遇残废之祸患，甚至发狂杀人或变死，乃短寿又凶死之兆矣。'
  },
  '火金火': { 
    type: '大凶',
    numbers: ['373', '484'],
    description: '命运完全被压制而不能伸展，基础不稳，伤脑伤肺，绝对的不安定，亦不能成功，晚年更凶，易遭火灾，甚至发狂或遭遇残废，变死之厄难，必定短寿凶死之兆矣。平生：贪色、好胜、争斗杀伐而惹祸，致陷遭牢狱者也不少。'
  },
  '火金土': { 
    type: '吉凶参半',
    numbers: ['375', '486'],
    description: '境遇虽安定，受一时之福荫而获得安定之生活，但成功运因被压制，不能有所伸张，常有烦恼与困难，身心过劳，易生脑疾、肺疾或遭难之虑，晚年不佳之兆。'
  },
  '火金金': { 
    type: '大凶',
    numbers: ['377', '488'],
    description: '过分坚决鲁顽刚强，以致遭受批难、不和，陷于孤独，易生不平、不满、怨叹等。成功运被抑压，且易变为遭难以及失子、孤独、不遇等。容易因不测之突变而短寿丧生之兆。'
  },
  '火金水': { 
    type: '大凶',
    numbers: ['379', '480'],
    description: '非但不能成功，且有急变没落之兆，陷于怀才不遇，破乱凶祸极多，平生意志不能有所伸张，成功运也完全被压制，容易因被人连累而遭难，突生不测凶变而丧生，死于少人知之处。'
  },
  '火水木': { 
    type: '凶多吉少',
    numbers: ['391', '402'],
    description: '虽有一时的成功，但因成功运被压制，而不能有所伸张，且大多易生困苦、乱杂、穷困，且有招致急祸或遭难之虑，含有急变不祥之兆。'
  },
  '火水火': { 
    type: '大凶',
    numbers: ['393', '404'],
    description: '三才皆破，乱杂困穷，容易在室外或途中而遭难，有急祸，无形之心病甚重，容易为感情或爱情事而遭难，大灾、大祸频袭，如风中残烛，随时可灭之兆，绝对的不安全，不但身体越虚弱，且会发生不测之突变，而丧生或发狂或自杀，乃短寿之兆。'
  },
  '火水土': { 
    type: '大凶',
    numbers: ['395', '406'],
    description: '三才皆破，即使表面安定，亦内藏不安，乱杂困苦烦闷，基础运崩败而成功运又被抑压，不能伸张，不但招致境遇没落，又有病弱短命及遭难变死之兆，为短寿之凶数配置。'
  },
  '火水金': { 
    type: '大凶',
    numbers: ['397', '408'],
    description: '能有一时之成功，但成功运被压制而不能伸张，时常不平、不满、乱杂苦闷烦难恼，灾祸繁多，为平安，须提防处事，否则会有突然之急祸凶变。'
  },
  '火水水': { 
    type: '大凶',
    numbers: ['399', '400'],
    description: '有一时之投机成功，但绝对不能伸张，终归乱杂困苦、孤独、有病难、凶变、急祸，危命之虑。'
  },
  '火土木': { 
    type: '吉多于凶',
    numbers: ['351', '462'],
    description: '虽得尊长（或上司）之爱护提拔，或祖先之余德，而必可成功发展，但基础是（土在上而木在下）之相克而含有崩败运，故境遇多凶变，财帛易散，成败频见，身份也因之时贵、时贱。'
  },
  '火土火': { 
    type: '大吉',
    numbers: ['353', '464'],
    description: '能安定，可逃灾害，部下得力合作，能成功，由尊长之爱护提拔或父祖余德所荫益，得隆昌而大发展。'
  },
  '火土土': { 
    type: '大吉',
    numbers: ['355', '466'],
    description: '有父祖余德所荫益，或由长辈爱护栽培，易向上发展，境遇安泰，虽无惊人成就，但可平顺而逐渐伸展，欣庆幸福长寿之兆。'
  },
  '火土金': { 
    type: '大吉',
    numbers: ['357', '468'],
    description: '得部下拥载，及长辈引进，而得成功发展（五行顺相生，从上生下，配置良好），易得财利、名誉、事业隆昌，长寿少病之兆。'
  },
  '火土水': { 
    type: '吉多于凶',
    numbers: ['359', '460'],
    description: '虽有长辈的爱护提拔，或父祖之余德荫益，而可成功于中年或壮年，但基础运劣，须防青年或晚年期之急变没落或遭受病苦、破财、失败或因色情事被杀等之不安定，凶运频来之兆。'
  },
  // 土系配置
  '土木木': { 
    type: '中吉',
    numbers: ['511', '622'],
    description: '基础安泰，得贵人助力，而在困难之中得平安发展，但成功运之配置不良，难于伸张，故然只是外强中干而已，虽苦闷烦恼殊多，但大体可得平安，衣食充足，幸福有寿，人地两格，无凶数，则身体健康，疾病少有，有病吃药即可速愈。'
  },
  '土木火': { 
    type: '中吉',
    numbers: ['513', '624'],
    description: '勤勉做事，无厄安泰，终获成功之吉兆无疑，虽然成功较迟些，但平安发展，改善境遇，家门兴隆，但过程中亦有不少困苦烦恼。如果人、地两格无凶数，则无病，若有病吃药可速愈。'
  },
  '土木土': { 
    type: '大凶',
    numbers: ['515', '626'],
    description: '虽获得成功发展，但因基础不稳而易再变化转移，腹部、肠胃易患疾病。'
  },
  '土木金': { 
    type: '中吉',
    numbers: ['517', '628'],
    description: '欣庆果能成功顺调，容易发展达到目的，亦能成富、成贵，唯在幼少年期之境遇不稳安而较多变化、若为凶数尤其以幼少年期间，恐有胃肠疾患及遭崩塌或坠落物所伤之虑。'
  },
  '土木水': { 
    type: '大凶',
    numbers: ['519', '620'],
    description: '境遇安全，长辈惠泽，承受父祖之余德，前辈之提拔，而可获得意外之成功发达。但数理若凶，或许陷于病弱。'
  },
  '土火木': { 
    type: '吉', 
    description: '基础坚实，成功顺利，而且向上发展成功，品性好，可享幸福长寿，大吉。'
  },
  '土火火': { 
    type: '大吉',
    numbers: ['533', '644'],
    description: '一鼓作气，勇猛奋斗，运势浩盛，容易成功达到目的，功名成就，若原命喜火之人，妙能以此之名更加两倍以上之辉煌成就，然若凶数则欠人助，以自力奋斗，也易招孤苦失意，令人可惜。'
  },
  '土火土': { 
    type: '大吉',
    numbers: ['535', '646'],
    description: '三才配置至为优胜，基础坚实，希望如意，求谋容易达成目的，功名成就，成功后之发展如飞黄腾达，得上位之人所器，受下属之拥护，大幸福之长寿兆。'
  },
  '土火金': { 
    type: '凶', 
    description: '虽可得一时之成功，但因基础运不稳，要防突变、转失。'
  },
  '土火水': { 
    type: '吉多于凶',
    numbers: ['539', '640'],
    description: '虽可获得一时之成功，但因基础运太劣，尤其水火相克最为激烈而早应，所以要提防火灾或烫伤之灾。但若人格与地格皆属数者，他格又有凶数：很可能好淫无节制。'
  },
  '土土木': { 
    type: '中吉',
    numbers: ['551', '662'],
    description: '成功较迟，但必可成功发展，不过因其基础不稳，而容易变化或移动，或多成多败或有胃肠病之虑，幸而福泽较大，而足以化凶为呈祥。'
  },
  '土土火': { 
    type: '大吉',
    numbers: ['553', '664'],
    description: '基础稳固安泰，且能逃过灾害，免于祸患，而又可排除万难及得享名利双收之隆昌运，并获意外的成功发展，乃幸福长寿之吉名。'
  },
  '土土土': { 
    type: '大吉',
    numbers: ['555', '666'],
    description: '气运、财运皆坚固平安，大体平顺幸福，障碍少而且均能处理解决，成功运佳，虽成功较迟，但可达到希望目的，并可续渐伸张发展。如果人格、地格、外格：若是或数者，虽然雅量广但多数不重视贞操，若果能够成为连珠格局更佳。'
  },
  '土土金': { 
    type: '大吉',
    numbers: ['557', '668'],
    description: '境遇安泰，身心健全，希望目的达成，能逃过灾害而免祸患，安定成功，优秀伸张发展，一帆风顺之三才佳配。'
  },
  '土土水': { 
    type: '大凶',
    numbers: ['559', '660'],
    description: '虽可成功于一时，但必会陷于失败，家庭离乱尤其有急变之灾祸。'
  },
  '土金木': { 
    type: '中吉',
    numbers: ['571', '682'],
    description: '欣庆果能成功顺调，容易发展达到目的，亦能成富、成贵，唯在幼少年期之境遇不稳安而较多变化、若为凶数尤其以幼少年期间，恐有胃肠疾患及遭崩塌或坠落物所伤之虑。'
  },
  '土金火': { 
    type: '大吉',
    numbers: ['573', '684'],
    description: '可获得意外之大成功，名利双收，且得大发展，诸事顺利隆昌，大吉大利。但数理若凶则恐好景不长。若无凶数，则可免忧虑。'
  },
  '土金土': { 
    type: '大吉',
    numbers: ['575', '686'],
    description: '三才配置甚佳，基础运坚固，境遇安泰，喜下属忠心扶助，得长辈或上司之惠泽引进，努力奋斗，可轻易得成功，及伸张发展，很幸福安全之佳名。'
  },
  '土金金': { 
    type: '大吉',
    numbers: ['577', '688'],
    description: '基础运虽平吉但成功运却甚佳，能得上司或长辈之提拔而得大发展，优秀之良配，但要勤勉，再加上说话及处事均力求和平稳健，而切莫得罪人（不可孤高、自大、刚硬、好胜、出风头等皆忌之，若得罪人须诚心道歉），始方能得大成功及发展。人格地格数，若无凶，身心健而无病。'
  },
  '土金水': { 
    type: '吉多于凶',
    numbers: ['579', '680'],
    description: '青年多劳，切莫悲观则劳终有成，与人合伙须善处理，更胜独营。于中年或壮年可得成功，名利双收，并得大发展之庆，可惜因基础运劣，使成功运受牵制，故突发之灾遇或损失也不少。'
  },
  // 金系配置
  '金木木': { 
    type: '大凶',
    numbers: ['711', '822'],
    description: '虽有一时之成功，但因成功运被压制，而不能有所伸张，且大多易生困苦、乱杂、穷困，且有招致急祸或遭难之虑，含有急变不祥之兆。'
  },
  '金木火': { 
    type: '大凶',
    numbers: ['713', '824'],
    description: '虽因苦心奋斗而有成功运，但基础运劣，故伸张无力，又境遇多变，常受迫害，难得平安，屡受下属威胁，为部下而致损失，劳烦、失败等，心情苦闷。又有急变不祥之兆。'
  },
  '金木土': { 
    type: '凶多吉少',
    numbers: ['715', '826'],
    description: '基础运佳而成功运劣，虽无大发展，但亦安定，温饱无虑，但成功运被压迫以致不能再伸张发达，故好发牢骚，幸而德量好，小过难免，但不致成祸厄。'
  },
  '金木金': { 
    type: '大凶',
    numbers: ['717', '828'],
    description: '成功运被压抑，不能有所伸张，尤其容易遭遇急变、没落及招来不测之灾，易生腹部疾病。'
  },
  '金木水': { 
    type: '大凶',
    numbers: ['719', '820'],
    description: '虽有一时之成功且能发展，但因基础运太劣，恐再度陷于急变，病难、短命之配置。'
  },
  '金火木': { 
    type: '大凶',
    numbers: ['731', '842'],
    description: '命运完全被抑压，基础运亦劣，常常劳而无功，极困难伸展其成就，且有患精神病之虑。'
  },
  '金火火': { 
    type: '大凶',
    numbers: ['733', '844'],
    description: '虽有一时之成功，但基础薄弱，缺乏耐久力，故易陷于失败，若轻浮疏忽便招致失败。'
  },
  '金火土': { 
    type: '吉凶参半',
    numbers: ['735', '846'],
    description: '境遇虽安定，受一时之福荫而获得安定之生活，但成功运因被压制，不能有所伸张，常有烦恼与困难，身心过劳，易生脑疾、肺疾或遭难之虑，晚年不佳之兆。'
  },
  '金火金': { 
    type: '大凶',
    numbers: ['737', '848'],
    description: '过分坚决鲁顽刚强，以致遭受批难、不和，陷于孤独，易生不平、不满、怨叹等。成功运被抑压，且易变为遭难以及失子、孤独、不遇等。容易因不测之突变而短寿丧生之兆。'
  },
  '金火水': { 
    type: '大凶',
    numbers: ['739', '840'],
    description: '非但不能成功，且有急变没落之兆，陷于怀才不遇，破乱凶祸极多，平生意志不能有所伸张，成功运也完全被压制，容易因被人连累而遭难，突生不测凶变而丧生，死于少人知之处。'
  },
  '金土木': { 
    type: '中吉',
    numbers: ['751', '862'],
    description: '欣庆果能成功顺调，容易发展达到目的，亦能成富、成贵，唯在幼少年期之境遇不稳安而较多变化、若为凶数尤其以幼少年期间，恐有胃肠疾患及遭崩塌或坠落物所伤之虑。'
  },
  '金土火': { 
    type: '大吉',
    numbers: ['753', '864'],
    description: '可获得意外之大成功，名利双收，且得大发展，诸事顺利隆昌，大吉大利。但数理若凶则恐好景不长。若无凶数，则可免忧虑。'
  },
  '金土土': { 
    type: '大吉',
    numbers: ['755', '866'],
    description: '易达目的，轻易成功，名利双收，一帆风顺，福泰鸿量，万事安宁，顺利发展，生涯境遇安泰，即使数理有凶也可免于灾祸。'
  },
  '金土金': { 
    type: '大吉',
    numbers: ['757', '868'],
    description: '基础稳固，希望易达，顺利成功发展，名誉与福份俩俱充足，隆昌威仪，大成功、大余庆、繁华荣隆。'
  },
  '金土水': { 
    type: '吉多于凶',
    numbers: ['759', '860'],
    description: '青年多劳，切莫悲观则劳终有成，与人合伙须善处理，更胜独营。于中年或壮年可得成功，名利双收，并得大发展之庆，可惜因基础运劣，使成功运受牵制，故突发之灾遇或损失也不少。'
  },
  '金金木': { 
    type: '大凶',
    numbers: ['771', '882'],
    description: '基础运及成功运皆不佳，无任何发展，且有衰败没落之虑，且易生急变灾死之配置，更须提防交通事故。'
  },
  '金金火': { 
    type: '大凶',
    numbers: ['773', '884'],
    description: '基础运及成功运皆不佳，无任何发展，且有衰败没落之虑，且易生急变灾死之配置，更须提防交通事故。'
  },
  '金金土': { 
    type: '大吉',
    numbers: ['775', '886'],
    description: '容易成功，达到目的，境遇安固，身心健全，名利双收，威权显达，运势昌隆。'
  },
  '金金金': { 
    type: '中吉',
    numbers: ['777', '888'],
    description: '此兆难论吉凶，若配吉数则判为吉，若有凶数即变为小吉而已而视作而已。但限于此数连结顺调者，宜用此数之人，或者其人生来就喜欢金者，则可视为中吉。'
  },
  '金金水': { 
    type: '中吉',
    numbers: ['779', '880'],
    description: '以坚志毅力，克服艰难，达成功扩展，身心皆健，若生辰之原命喜金水者，得此名更佳。但人、地两格其一是凶者，则虽也能成功发展于一时，但终因急变而逐渐的没落崩败或失和、孤立或遭遇危身灾险。'
  },
  '金水木': { 
    type: '大吉',
    numbers: ['791', '802'],
    description: '境遇安全，长辈惠泽，承受父祖之余德，前辈之提拔，而可获得意外之成功发达。但数理若凶，或许陷于病弱。'
  },
  '金水火': { 
    type: '大凶',
    numbers: ['793', '804'],
    description: '能有一时之成功，但成功运被压制而不能伸张，时常不平、不满、乱杂苦闷烦难恼，灾祸繁多，为平安，须提防处事，否则会有突然之急祸凶变。'
  },
  '金水土': { 
    type: '吉',
    numbers: ['795', '806'],
    description: '得长辈或上司之惠助，再加上自身之勤勉，而于中年或壮年可获得相当之发展，但因基础运劣，于成功之后，又会有很多次之再成败，生涯多劳，难亨安逸。幸而水在土上，池塘之家，亦顺天然之景故，虽是相克，凶意不大。'
  },
  '金水金': { 
    type: '大吉',
    numbers: ['797', '808'],
    description: '基础稳固安然，财源广进，又有父祖之荫益及上司之提拔，易得意外之助力，而可获得大成功，大发展，名利丰收。威权、名望、地位俱皆兴隆宽宏殊胜之配置。'
  },
  '金水水': { 
    type: '中吉',
    numbers: ['799', '800'],
    description: '承父祖之余德，得长者之栽培，或用人得当，得大成功及发展，原命若喜水木者更佳。若凶数者：成又转败，陷于离乱变动，至晚年终归孤独失败，又早年有落水厄遇，生涯九死一生之命格。又须戒色，以防色变及刀杀之危。'
  },
  // 水系配置
  '水木木': { 
    type: '大吉',
    numbers: ['911', '022'],
    description: '基础安泰，长辈惠助，排除万难，而顺利成功及发展，繁荣隆昌，人缘殊胜，利荫六亲。'
  },
  '水木火': { 
    type: '大吉',
    numbers: ['913', '024'],
    description: '可得平安荣华之幸运，及能受父祖余德或财力所荫益，达到成功与大发展，但其过程伏有许多艰难，最怕人格与地格若是凶数，终归失败，若无凶数，则可免忧。'
  },
  '水木土': { 
    type: '大吉',
    numbers: ['915', '026'],
    description: '基础运乃木在上而土在下，顺应天地自然之配置（不作木土相克论），犹若立于盘石之上，相得益彰而毫无凶变，境遇安全而顺利之安泰成功，并隆昌发达。'
  },
  '水木金': { 
    type: '大凶',
    numbers: ['917', '028'],
    description: '成功运被压抑，不能有所伸张，尤其容易遭遇急变、没落及招来不测之灾，易生腹部疾病。'
  },
  '水木水': { 
    type: '大吉',
    numbers: ['919', '020'],
    description: '青年期甚劳苦，因勤奋求上进而在中年末，虽可很顺利成功并发展隆昌长久。但人、地格，有凶数者：在晚年或许会再产生艰难、困苦、劳心，甚至遭致失败之忧。此三才局，若数理无凶，即无病，有病吃药即可速愈。'
  },
  '水火木': { 
    type: '中吉',
    numbers: ['931', '042'],
    description: '境遇坚固安泰，有下属之助力，地位、财产均安全，以木解水火之相克，致成功，但若人地格有凶数，于成功后，难以伸展，且有突发之灾祸、遭难等之虑，更容易发生因爱情上而产生之不测灾难、凶变等。'
  },
  '水火火': { 
    type: '大凶',
    numbers: ['933', '044'],
    description: '三才皆破，乱杂困穷，容易在室外或途中而遭难，有急祸，无形之心病甚重，容易为感情或爱情事而遭难，大灾、大祸频袭，如风中残烛，随时可灭之兆，绝对的不安全，不但身体越虚弱，且会发生不测之突变，而丧生或发狂或自杀，乃短寿之兆。'
  },
  '水火土': { 
    type: '大凶',
    numbers: ['935', '046'],
    description: '三才皆破，即使表面安定，亦内藏不安，乱杂困苦烦闷，基础运崩败而成功运又被抑压，不能伸张，不但招致境遇没落，又有病弱短命及遭难变死之兆，为短寿之凶数配置。'
  },
  '水火金': { 
    type: '大凶',
    numbers: ['937', '048'],
    description: '能有一时之成功，但成功运被压制而不能伸张，时常不平、不满、乱杂苦闷烦难恼，灾祸繁多，为平安，须提防处事，否则会有突然之急祸凶变。'
  },
  '水火水': { 
    type: '大凶',
    numbers: ['939', '040'],
    description: '有一时之投机成功，但绝对不能伸张，终归乱杂困苦、孤独、有病难、凶变、急祸，危命之虑。'
  },
  '水土木': { 
    type: '大凶',
    numbers: ['951', '062'],
    description: '境遇安全，长辈惠泽，承受父祖之余德，前辈之提拔，而可获得意外之成功发达。但数理若凶，或许陷于病弱。'
  },
  '水土火': { 
    type: '中吉',
    numbers: ['953', '064'],
    description: '基础安定，能逃灾害，排除障碍而达到成功。不过却因成功运不吉，不能再伸展。不能将天赋才能以完全发展，使其成就与精华俱皆受到打折，殊为可惜，又须深戒提防色难之忧。'
  },
  '水土土': { 
    type: '中吉',
    numbers: ['955', '066'],
    description: '境遇安定，平顺幸福，能排除困难，广得人助，而得到名利双收之大成功，生活安逸，可惜因成功运不理想，是以向上伸展产生障碍颇多，只能维持原有旧日之成就现状而已。'
  },
  '水土金': { 
    type: '中吉',
    numbers: ['957', '068'],
    description: '基础运佳，故而可以安定发展，排除万难而成功，但因成功运不吉，难于再伸展，或陷于不测之灾难袭来之虑，若无凶数则可免忧，亦可康健无病。'
  },
  '水土水': { 
    type: '大凶',
    numbers: ['959', '060'],
    description: '虽可成功于一时，但必会陷于失败，家庭离乱尤其有急变之灾祸。'
  },
  '水金木': { 
    type: '大吉',
    numbers: ['971', '082'],
    description: '境遇安全，长辈惠泽，承受父祖之余德，前辈之提拔，而可获得意外之成功发达。但数理若凶，或许陷于病弱。'
  },
  '水金火': { 
    type: '大凶',
    numbers: ['973', '084'],
    description: '能有一时之成功，但成功运被压制而不能伸张，时常不平、不满、乱杂苦闷烦难恼，灾祸繁多，为平安，须提防处事，否则会有突然之急祸凶变。'
  },
  '水金土': { 
    type: '大吉',
    numbers: ['975', '086'],
    description: '学竟有成，凡事如意，顺利成功，达成目的，名利双收，境遇安固，优越发展，享尽幸福。'
  },
  '水金金': { 
    type: '中吉',
    numbers: ['977', '088'],
    description: '勤苦竟成之吉兆无疑，勤勉上进，坚志如铁，个性顽刚，不肯屈服，具有深厚实力之才华，凭以创造锦绣而辉煌之前程，博得功成名就，并得到很大伸展，但唯憾的是与人不大融洽。'
  },
  '水金水': { 
    type: '大吉',
    numbers: ['979', '080'],
    description: '基础运及成功运皆佳，且身心健全，而可稳达成功发展成富或扬名美誉。若地格凶数则成又转败，且遭溺水或水灾之损。'
  },
  '水水木': { 
    type: '大吉',
    numbers: ['991', '002'],
    description: '基础运佳，境遇安全，而可顺利成功，成功运也不错，因之亦可向上伸展发达，人格凶数，陷于行为不修，品性不端，恐过于放荡不羁之虑，易生破乱变动或荒亡流败之虑，请好自为之，而得免于损失自福。若无凶数便无灾祸之忧。'
  },
  '水水火': { 
    type: '大凶',
    numbers: ['993', '004'],
    description: '三才皆破，乱杂困穷，容易在室外或途中而遭难，有急祸，无形之心病甚重，容易为感情或爱情事而遭难，大灾、大祸频袭，如风中残烛，随时可灭之兆，绝对的不安全，不但身体越虚弱，且会发生不测之突变，而丧生或发狂或自杀，乃短寿之兆。'
  },
  '水水土': { 
    type: '大凶',
    numbers: ['995', '006'],
    description: '虽可成功于一时，但必会陷于失败，家庭离乱尤其有急变之灾祸。'
  },
  '水水金': { 
    type: '大吉',
    numbers: ['997', '008'],
    description: '基础健固，境遇安然，勤智交辉而能博得财利名誉以及名利双收，大成功，大发展之兆，但若品行不修，不守正道，便会沦陷于刑牢狱之灾，若多不平不满则与人不和，荒亡流散或有害健康，若无凶数便无灾害。'
  },
  '水水水': { 
    type: '中吉',
    numbers: ['999', '000'],
    description: '唯独若有连珠局者，论为大吉，原命喜水尤佳。有一时之大势力，大发展而得名取利，但若品行不端，行为不修，胜与败均极端而短暂终于变成荒亡流散，如泡沬梦幻而结果是悲运灭亡又孤独伶仃人生。'
  }
}

// 基于权威文献的三才配置分类（7级分类标准）
export const THREE_TALENTS_BY_LEVEL = {
  大吉: [
    '木木木', '木木火', '木木土', '木火土', '木水木', '木水金', '木水水',
    '火木木', '火木火', '火木土', '火火木', '火火土', '火土木', '火土火', '火土土', '火土金',
    '土火木', '土火火', '土火土', '土土火', '土土土', '土土金', '土金土', '土金金', '土金水',
    '金土火', '金土土', '金土金', '金金土', '金水木', '金水金', '金水水',
    '水木木', '水木火', '水木土', '水木水', '水金土', '水金水', '水水木', '水水金'
  ],
  
  中吉: [
    '木火火', '木土火', '火木水', '土木木', '土木火', '土土木',
    '金土木', '金金金', '金金水', '水火木', '水土火', '水土土', '水土金', '水金金', '水水水'
  ],
  
  吉: [
    '木土土', '金水土'
  ],
  
  吉多于凶: [
    '木木水', '木土金', '火土水', '土火水', '金土水'
  ],
  
  吉凶参半: [
    '木金土', '火火火', '火金土', '火金金', '金火火', '金火土', '土水金'
  ],
  
  凶多于吉: [
    '木木金', '木火木', '木火金', '木水火', '木水土', '火木金', '土木土', '土木金', '土木水', '土土水',
    '土金木', '土金火', '土火金', '土水木', '金木木', '金木火', '金木土', '金木水',
    '金火木', '金水火', '水木金', '水火土', '水金木', '水金火'
  ],
  
  大凶: [
    '木火水', '木土木', '木土水', '木金木', '木金火', '木金金', '木金水',
    '火火金', '火火水', '火金木', '火金火', '火金水', '火水木', '火水火', '火水土', '火水金', '火水水',
    '土水火', '土水土', '土水水', '金木金', '金火金', '金火水', '金金木', '金金火',
    '水火火', '水火金', '水火水', '水土木', '水土水', '水水火', '水水土'
  ]
}

// 根据三才数字计算三才配置
export const calculateThreeTalents = (tianGe, renGe, diGe) => {
  const tianElement = getElementByNumber(tianGe)
  const renElement = getElementByNumber(renGe)  
  const diElement = getElementByNumber(diGe)
  
  const config = `${tianElement}${renElement}${diElement}`
  
  return {
    tianElement,     // 天才五行
    renElement,      // 人才五行
    diElement,       // 地才五行
    config,          // 三才配置
    fortune: THREE_TALENTS_FORTUNE[config] || { 
      type: '一般', 
      description: '此三才配置较为平常，无特别突出的优势或劣势。' 
    }
  }
}

// 判断三才是否为吉配（包含大吉、中吉、吉、吉多于凶）
export const isGoodThreeTalents = (tianGe, renGe, diGe) => {
  const result = calculateThreeTalents(tianGe, renGe, diGe)
  const goodTypes = ['大吉', '中吉', '吉', '吉多于凶']
  return goodTypes.includes(result.fortune.type)
}

// 获取推荐的三才配置
export const getRecommendedThreeTalents = () => {
  return Object.entries(THREE_TALENTS_FORTUNE)
    .filter(([config, data]) => data.type === '吉' || data.type === '大吉')
    .map(([config, data]) => ({
      config,
      type: data.type,
      description: data.description
    }))
}

// 按五行分类获取凶吉组合
export const getThreeTalentsByElement = (element) => {
  const levels = ['大吉', '中吉', '吉', '吉多于凶', '吉凶参半', '凶多于吉', '大凶']
  const result = {}
  
  levels.forEach(level => {
    result[level] = THREE_TALENTS_BY_LEVEL[level]
      .filter(config => config.startsWith(element))
      .map(config => ({
        config,
        type: level,
        tianElement: config[0],
        renElement: config[1], 
        diElement: config[2],
        description: THREE_TALENTS_FORTUNE[config]?.description || '暂无详细描述'
      }))
  })
  
  return result
}

// 获取指定天格五行的所有配置统计
export const getElementStatistics = (element) => {
  const elementConfigs = Object.keys(THREE_TALENTS_FORTUNE)
    .filter(config => config.startsWith(element))
  
  const statistics = {
    总数: elementConfigs.length,
    大吉: 0,
    中吉: 0,
    吉: 0,
    吉多于凶: 0,
    吉凶参半: 0,
    凶多于吉: 0,
    大凶: 0
  }
  
  elementConfigs.forEach(config => {
    const fortune = THREE_TALENTS_FORTUNE[config]
    if (fortune && statistics.hasOwnProperty(fortune.type)) {
      statistics[fortune.type] = (statistics[fortune.type] || 0) + 1
    }
  })
  
  // 计算吉利配置占比
  const goodCount = statistics.大吉 + statistics.中吉 + statistics.吉 + statistics.吉多于凶
  statistics.吉利占比 = Math.round((goodCount / statistics.总数) * 100) + '%'
  
  return statistics
}

// 获取所有五行的统计对比
export const getAllElementsStatistics = () => {
  const elements = ['木', '火', '土', '金', '水']
  const result = {}
  
  elements.forEach(element => {
    result[element] = getElementStatistics(element)
  })
  
  return result
}

// 根据天格数理获取配置建议
export const getConfigsByTianGe = (tianGeNumber) => {
  const tianElement = getElementByNumber(tianGeNumber)
  const levels = ['大吉', '中吉', '吉', '吉多于凶', '吉凶参半', '凶多于吉', '大凶']
  const result = {
    tianGe: tianGeNumber,
    tianElement: tianElement,
    suggestions: {}
  }
  
  // 按等级分类获取所有以该五行开头的配置
  levels.forEach(level => {
    const configs = THREE_TALENTS_BY_LEVEL[level]
      .filter(config => config.startsWith(tianElement))
      .map(config => {
        const configData = THREE_TALENTS_FORTUNE[config]
        const tianChar = config[0]
        const renChar = config[1] 
        const diChar = config[2]
        
        // 使用 THREE_TALENTS_FORTUNE 中预定义的 numbers 数组
        const examples = []
        if (configData && configData.numbers && configData.numbers.length > 0) {
          // 使用预定义的数字组合
          configData.numbers.forEach(numberStr => {
            if (numberStr.length === 3) {
              const tianNum = parseInt(numberStr[0])
              const renNum = parseInt(numberStr[1])
              const diNum = parseInt(numberStr[2])
              
              examples.push({
                combination: `${tianNum}${renNum}${diNum}`,
                elements: `${tianChar}${renChar}${diChar}`,
                description: `天格${tianNum}(${tianChar}) 人格${renNum}(${renChar}) 地格${diNum}(${diChar}) ${configData.type}`
              })
            }
          })
        } else {
          // 如果没有预定义数字，生成一个基本示例
          const tianLastDigit = tianGeNumber % 10
          const renLastDigit = (tianLastDigit + 1) % 10 || 1
          const diLastDigit = (tianLastDigit + 2) % 10 || 1
          
          examples.push({
            combination: `${tianLastDigit}${renLastDigit}${diLastDigit}`,
            elements: `${tianChar}${renChar}${diChar}`,
            description: `天格${tianLastDigit}(${tianChar}) 人格${renLastDigit}(${renChar}) 地格${diLastDigit}(${diChar}) ${configData?.type || level}`
          })
        }
        
        return {
          config: config,
          type: level,
          tianElement: tianChar,
          renElement: renChar,
          diElement: diChar,
          description: configData?.description || '暂无详细描述',
          examples: examples
        }
      })
    
    if (configs.length > 0) {
      result.suggestions[level] = configs
    }
  })
  
  return result
}
